import { render, staticRenderFns } from "./StdInput.vue?vue&type=template&id=64c951c4"
import script from "./StdInput.vue?vue&type=script&lang=js"
export * from "./StdInput.vue?vue&type=script&lang=js"
import style0 from "./StdInput.vue?vue&type=style&index=0&id=64c951c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports